'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('InspirationsListCtrl', InspirationsListCtrl);
  InspirationsListCtrl;

  InspirationsListCtrl.$inject = ['$state', '$scope', '$rootScope'];

  /* @ngInject */
  function InspirationsListCtrl($state, $scope, $rootScope) {
    // this logic is needed to select active md-nav-item in the _inspiration-nav.pug 
    var vm = this;
    var stateChangePointer = void 0;
    // workaround for md-nav-bar for accessibility
    var navElement = angular.element(document.querySelector('._md-nav-bar-list'));
    navElement.attr('tabindex', '0');

    if (_.startsWith($state.current.name, 'vnext.content.inspirations.list')) {
      if (_.endsWith($state.current.name, 'category')) {
        vm.currentNavItem = $state.current.name + '.' + ($state.params.type || 'popular');
      } else {
        vm.currentNavItem = $state.current.name;
      }
      stateChangePointer = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
        if (_.endsWith(toState.name, 'category')) {
          vm.currentNavItem = toState.name + '.' + (toParams.type || 'popular');
        } else {
          vm.currentNavItem = toState.name;
        }
      });
    }
    $scope.$on('$destroy', stateChangePointer);
  }
})();